import { EngineeringProgram } from 'screens/engineering-program';

export default EngineeringProgram;
